import { render, staticRenderFns } from "./PT507GTMRemoveFromCart.vue?vue&type=template&id=460f2d9f&"
import script from "./PT507GTMRemoveFromCart.vue?vue&type=script&lang=js&"
export * from "./PT507GTMRemoveFromCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports